export const MU_SET_PHOTO_FILENAME = 'mutations/student/photoFilename'
